import React from "react";
import { Link } from "react-router-dom";
import "./terms.css";

export default function Privacy() {
  return (
    <main dir="rtl" lang="he" className="container legal-page" role="main" aria-labelledby="privacy-title">
      <a href="#content" className="sr-only-focusable">דלג לתוכן</a>
      <div className="logo-container-sign logo-container-privacy">
        <Link to="/">
          <img src="/icons/green-logo.png" alt="Logo" className="logo" />
        </Link>
      </div>
      <h1 id="privacy-title">מדיניות פרטיות – Heyi</h1>

      <section id="content" aria-labelledby="effective-date">
        <p><strong>תוקף אחרון:</strong> 10.09.2025</p>
        <p>
          ב-Heyi אנו מכבדים את פרטיות המשתמשים ומתחייבים לשמור על המידע האישי שנמסר לנו או שנשמר במערכת במסגרת השירות.
          מדיניות זו מתארת אילו נתונים נאספים, כיצד משתמשים בהם, היכן נשמרים, ומהן הזכויות של המשתמשים.
        </p>
      </section>

      <section aria-labelledby="data-types">
        <h2 id="data-types">1. סוגי מידע שנאספים</h2>
        <h3>א. מארחים וצלמים</h3>
        <ul>
          <li>פרטים אישיים: שם, כתובת דוא״ל, מספר טלפון.</li>
          <li>שימוש: פתיחת חשבון, ניהול אירוע, העלאת תמונות.</li>
        </ul>
        <h3>ב. אורחים באירוע</h3>
        <ul>
          <li>תמונת סלפי לצורך זיהוי <strong>אינה נשמרת</strong>; משמשת רק ליצירת מזהה דיגיטלי זמני לצורך השוואת פנים.</li>
          <li>תמונות האירוע שמועלות על-ידי המארח/הצלם עשויות לכלול את דמות האורח ונשמרות בגלריה.</li>
        </ul>
        <h3>ג. מידע טכני</h3>
        <ul>
          <li>נתוני שימוש ואבטחה (כגון IP, דפדפן, מכשיר, שפה) לצורך תפעול והגנת השירות.</li>
        </ul>
      </section>

      <section aria-labelledby="usage">
        <h2 id="usage">2. שימוש במידע</h2>
        <ul>
          <li>הפעלת השירות: ניהול גלריות אירוע, איתור תמונות של אורחים.</li>
          <li>שיפור, תחזוקה ותמיכה טכנית.</li>
          <li>אבטחת מידע ומניעת שימוש לרעה.</li>
          <li>עמידה בהוראות הדין והרגולציה.</li>
        </ul>
      </section>

      <section aria-labelledby="storage">
        <h2 id="storage">3. שמירת מידע</h2>
        <ul>
          <li>פרטי מארחים/צלמים נשמרים כל עוד החשבון פעיל או לפי דרישת חוק.</li>
          <li>תמונות אירוע נשמרות ב-AWS S3 עד למחיקת האירוע או לפי בקשה.</li>
          <li>תמונת הסלפי של אורח <strong>נמחקת לאחר העיבוד</strong>; המזהה הזמני אינו נשמר.</li>
        </ul>
      </section>

      <section aria-labelledby="sharing">
        <h2 id="sharing">4. שיתוף מידע עם צד שלישי</h2>
        <ul>
          <li>אין העברת מידע אישי לצדדים שלישיים למעט ספקי שירות טכניים הנחוצים להפעלת השירות (למשל AWS).</li>
          <li>לא נמכור מידע לצדדים מסחריים.</li>
          <li>ייתכן ונמסור מידע לפי דרישת חוק או צו שיפוטי.</li>
        </ul>
      </section>

      <section aria-labelledby="rights">
        <h2 id="rights">5. זכויות המשתמש</h2>
        <ul>
          <li><strong>מארחים/צלמים:</strong> זכאים לעיין, לעדכן או למחוק את פרטי החשבון שלהם.</li>
          <li><strong>אורחים:</strong> יכולים לבקש להסיר תמונות מסוימות מהגלריה דרך המארח או באמצעות פנייה אלינו.</li>
        </ul>
      </section>

      <section aria-labelledby="security">
        <h2 id="security">6. אבטחת מידע</h2>
        <p>
          אנו משתמשים באמצעי אבטחה מתקדמים ושירותי ענן מאובטחים (AWS). הגישה למידע מוגבלת לעובדים מורשים בלבד.
        </p>
      </section>

      <section aria-labelledby="changes">
        <h2 id="changes">7. שינויים במדיניות</h2>
        <p>
          ייתכנו עדכונים למדיניות זו מעת לעת. הגרסה העדכנית תפורסם באתר/אפליקציה ותיכנס לתוקף עם פרסומה.
        </p>
      </section>

      <section aria-labelledby="contact">
        <h2 id="contact">8. יצירת קשר</h2>
        <p>
          שאלות או בקשות בנוגע לפרטיות:{" "}
          <a href="mailto:heyi.events@gmail.com">heyi.events@gmail.com</a> |{" "}
          <a href="tel:+972542001485">054-2001485</a>
        </p>
      </section>
    </main>
  );
}
